export interface SelectableTemplateLike {
  templateSubject?: string | null;
  templateHtml?: string | null;
}

export function isTemplateSelectableInRulesEngine(
  template: SelectableTemplateLike | null | undefined
): boolean {
  if (!template) {
    return false;
  }

  const subject = template.templateSubject || '';
  const body = template.templateHtml || '';
  return !subject.includes('{|Password|}') && !body.includes('{|Password|}');
}
